export const normaliseCountryValue = value =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const resolveCountryOption = (value, options = [], fallback = null) => {
  const normalisedValue = normaliseCountryValue(value);

  if (!normalisedValue) {
    return fallback;
  }

  const match = options.find(
    option => normaliseCountryValue(option.value) === normalisedValue
  );

  return match ? match.value : fallback;
};
